import { makeStyles } from '@mui/styles';
import { Colors } from 'utils';

export const claimPostStyles = makeStyles(() => ({
    postTheadStyle: {
        display: 'flex',
        backgroundColor: `${Colors.BackgroundWhite}`,
        borderRadius: '8px',
        height: '50px',
        width: '100%',
        alignItems: 'center',
        boxShadow: '0px 0px 6px 0px rgba(138, 138, 138, 0.24)',
    },
    claimPaymentBodyWrapper: {
        marginTop: '8px',
        overflow: 'auto',
    },

    claimPaymentBodyHead: {
        display: 'flex',
        backgroundColor: `#F2F4F8`,
        borderRadius: '8px 8px 0px 0px',
        height: '50px',
        alignItems: 'center',
        borderBottom: '1px solid rgba(208, 213, 221, 0.20)',
    },
    closed: {
        color: `${Colors.ThemeRed}`,
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '19px',
    },

    claimPaymentBodyHeadItem: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '19px',
        color: '#172B4D',
        padding: '0 12px',
        '@media(min-width: 1919px)': {
            padding: '0 32px',
        },
    },

    postThStyle: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#172B4D',
        padding: '0 12px',
        '@media(min-width: 1919px)': {
            padding: '0 32px',
        },
    },
    claimPaymentBodyHeadNoPaddings: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 12px 0 0',
        '@media(min-width: 1919px)': {
            padding: '0 16px 0 0',
        },
    },

    editButton: {
        marginTop: '2px',
        background: 'transparent',
        border: 'none',
        width: '40px',
        color: '#6FD231',
        fontWeight: '700',
        fontSize: '14px',
        lineHeight: '19px',
    },
    payInFull: {
        width: '101px',
        height: '32px',
        background: `${Colors.ThemeBlue}`,
        borderRadius: '4px',
        marginRight: '16px',
        fontWeight: '600',
        fontSize: '14',
        lineHeight: '19px',
        color: '#FFFFFF',
        border: 'none',
        whiteSpace: 'nowrap',
    },
    appeal: {
        width: '79px',
        height: '32px',
        background: `${Colors.ThemeRed}`,
        borderRadius: '4px',
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '19px',
        color: '#FFFFFF',
        border: 'none',
    },
    bodyItemWrapper: {
        width: '100%',
        height: 'auto',
        background: '#FFFFFF',
        borderRadius: '0px 0px 8px 8px',
        padding: '8px',

        '@media(min-width: 1919px)': {
            padding: '16px',
        },
    },
    bodyItemHead: {
        display: 'flex',
        alignItems: 'center',
        height: '36px',
        justifyContent: 'space-between',
    },
    bodyItemBody: {
        display: 'flex',
        // height: '36px',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #D8E5FF',
    },
    bodyItemHeadRow: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: 'normal',
        color: `#475467`,
        padding: '0 8px',
        '@media (min-width: 1920px)': {
            padding: '0 12px',
        },
    },
    bodyItemBodyRow: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: '400',
        fontSize: '14px',
        color: '#172B4D !important',
        padding: '0 8px',
        // '@media (min-width: 1920px)': {
        //     fontSize: '14px',
        //     padding: '0 12px',
        // },
        '& input': {
            border: 'none',
            background: 'transparent',
            height: '40px',
            outline: 'none',
            padding: 0,
            color: '#172B4D',
            fontWeight: '400',
            fontSize: '14px',
            width: '100%',
        },
        '& .numeric-format-input': {
            outline: 'none !important',
            width: '100%',
        },
    },
    payInFullBill: {
        fontWeight: '700',
        fontSize: '14px',
        lineHeight: '19px',
        color: `${Colors.BackgroundBlue}`,
        background: 'transparent',
        border: 'none',
        padding: '0',
        width: '72px',
        whiteSpace: 'nowrap',
    },
    paidStatusText: {
        fontWeight: 600,
        background: 'transparent',
        fontSize: '14px',
        color: `#027A48`,
    },
    paidStatus: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '16px',
        height: '22px',
        background: '#ECFDF3',
        padding: '2px 8px',
        gap: '4px',
        '& p': {
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '12px',
            color: `#027A48`,
        },
    },
    claimPaymentBodyHeadItemButtons: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
    },
    commentTextAreaStyle: {
        margin: 0,
        '& textarea': {
            maxWidth: '406px',
            width: '100%',
            height: '160px',
        },
    },
    closeOrCancelButnStyle: {
        width: '195px',
        '&.cancel': { backgroundColor: `${Colors.BackgroundWater} !important` },
        '&.create': { backgroundColor: `${Colors.ThemeRed} !important` },
    },
    paymentRefInput: {
        border: 'none',
        background: 'transparent',
        outline: 'none',
        color: `${Colors.TextSecondary}`,
        fontSize: '14px',
        fontWeight: '400',
    },
    dollar: {
        marginBottom: '1px',
    },
    buttonsWrapper: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '1px solid #475467',
        marginRight: '12px',
    },
    closeButton: {
        background: 'transparent',
        border: 'none',
        marginTop: '2px',
    },
    billedAmount: {
        display: 'flex',
        alignItems: 'center',
        height: '40px',
    },
}));
